import React, { useEffect, useState } from "react";
import "./Login.css";
import { Link, useHistory } from "react-router-dom";
import { auth, provider } from "../firebase";
import { db } from "../firebase";

function Login() {
  const history = useHistory();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    document.title = `Login to Accelerator`;
  }, []);

  const signIn = () => {
    auth
      .signInWithPopup(provider)
      .then((result) => {
        login(result.user)
      })
      .catch((error) => {
        // alert(error.message);
      });
  };

	// const register = (e) => {
	// 	e.preventDefault();

	// 	auth.createUserWithEmailAndPassword(email, password)
	// 		.then((auth) => {
  //       if(auth.uid);
	// 			if (auth) {
	// 				history.push("/");
	// 			}
	// 		})
	// 		.catch((error) => alert(error.message));
	// };

  const signInEmail = (e) => {
    e.preventDefault();
    auth
      .signInWithEmailAndPassword(email, password)
      .then((auth) => {
        history.push("/");
      })
      .catch((error) => alert(error.message));
  };


  
  const login = (user) => {
    try{
      db.collection("Users")
      .doc(user.uid)
      .get()
      .then((ds) => {
        if(ds.data()){
          history.push("/");
          alert("Welcome Back!")
        }else{
          db.collection("Users")
          .doc(user.uid)
          .set({
            id: user.uid,
            name: user.displayName,
            institute: "",
            dept: "",
            image: user.photoURL,
            email: user.email,
            bio: "",
            username: user.displayName.split(" ").at(0),
            location: "",
            score: 500,
            win: 0,
            lose: 0,
            draw: 0,
            type: 0,
            reward: 100,
            solved: 0,
            answers: 0,
            vote: 0,
            lastTimestamp: new Date().getTime()
          });
          history.push("/");
        }
      });
    }catch(e){
      db.collection("Users")
          .doc(user.uid)
          .set({
            id: user.uid,
            name: user.displayName,
            institute: "",
            dept: "",
            image: user.photoURL,
            email: user.email,
            bio: "",
            username: user.displayName.split(" ").at(0),
            location: "",
            score: 500,
            win: 0,
            lose: 0,
            draw: 0,
            type: 0,
            reward: 100,
            solved: 0,
            answers: 0,
            vote: 0,
            lastTimestamp: new Date().getTime(),
          });
          history.push("/");
    }
  };

  return (
    <div className="login">
      <div className="loginContainer">
        <Link to="/" className="link">
          <h1 className="loginLogo">Accelerator</h1>
        </Link>
        <h1>Sign-in</h1>

        <form>
          <h5>E-mail</h5>
          <input
            type="text"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <h5>Password</h5>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <button
            type="submit"
            onClick={signInEmail}
            className="loginSignInButton"
          >
            Sign In
          </button>
         
        </form>
        <Link to="/signup" >
        <button
          className="loginRegisterButton"
        >
          Create an account
        </button>
        </Link>

        <br />
        <h5>OR</h5>
        <button onClick={signIn} className="loginSignInButtonGoogle">
          <i className="fab fa-google"></i> Sign In with Google
        </button>

        <p>
          This is a experimental education community platfrom initated by
          <Link to="/post/about_app" >Jahangir Hossain.</Link>
        </p>
      </div>
    </div>
  );
}

export default Login;
